/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ContactrolesQueryResponse } from '../../types/GetV1Contactroles.ts'

export const getV1ContactrolesQueryKey = () => [{ url: '/v1/ContactRoles' }] as const

export type GetV1ContactrolesQueryKey = ReturnType<typeof getV1ContactrolesQueryKey>

/**
 * {@link /v1/ContactRoles}
 */
export async function getV1Contactroles(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1ContactrolesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/ContactRoles`,
        ...requestConfig,
    })
    return res
}

export function getV1ContactrolesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ContactrolesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ContactrolesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ContactrolesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Contactroles(config)
        },
    })
}

/**
 * {@link /v1/ContactRoles}
 */
export function useGetV1Contactroles<
    TData = ResponseConfig<GetV1ContactrolesQueryResponse>,
    TQueryData = ResponseConfig<GetV1ContactrolesQueryResponse>,
    TQueryKey extends QueryKey = GetV1ContactrolesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ContactrolesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ContactrolesQueryKey()

    const query = useQuery(
        {
            ...getV1ContactrolesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
